var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13725_45156)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27727 -0.154297C2.23806 -0.154297 0.584961 1.49881 0.584961 3.53801V14.9842C0.584961 17.0234 2.23806 18.6765 4.27727 18.6765H10.185C12.2242 18.6765 13.8773 17.0234 13.8773 14.9842V13.1928H12.4003V14.9842C12.4003 16.2077 11.4085 17.1995 10.185 17.1995H4.27727C3.05374 17.1995 2.06188 16.2077 2.06188 14.9842V3.53801C2.06188 2.31449 3.05375 1.32263 4.27727 1.32263H10.185C11.4085 1.32263 12.4003 2.31449 12.4003 3.53801V5.32936H13.8773V3.53801C13.8773 1.49881 12.2242 -0.154297 10.185 -0.154297H4.27727ZM14.3102 6.1964L14.8323 6.71858L16.3748 8.26101H8.00031H7.26184V9.73794H8.00031H16.8241L14.8323 11.7297L14.3102 12.2519L15.3545 13.2962L15.8767 12.7741L18.9044 9.74637L19.4265 9.2242L19.4265 9.22415L19.4265 9.2241L18.9044 8.70193L15.8767 5.67423L15.3545 5.15206L14.3102 6.1964Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13725_45156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4c2be749769d05bf9a8d2b53fe0078cf.svg";
export { ForwardRef as ReactComponent };